const projectData = [
    {
        id: 1,
        image: require('@/assets/images/companies/adsense_logo.png'),
        text: 'Implantação MobAgile Força de Vendas',
        subtext: 'Demanda MKT entregar mídia de book dos produtos, material PNG',
        users: [require('@/assets/images/users/post_1.jpg'), require('@/assets/images/users/post_2.jpg')],
        status: 'Concluído',
        date: '15 Jul, 23',
        comment: 214
    },
    {
        id: 2,
        image: require('@/assets/images/companies/insta_logo.png'),
        text: 'Prospecção testes 000888',
        subtext: 'Descrição última interação de usuário testes 0009',
        users: [require('@/assets/images/users/post_3.jpg')],
        status: 'Pendente',
        date: '22 Jul, 23',
        comment: 0
    },
    {
        id: 3,
        image: require('@/assets/images/companies/facebook_logo.png'),
        text: 'Prospecção testes 000455',
        subtext: 'Descrição última interação de usuário testes 0007',
        users: [require('@/assets/images/users/post_1.jpg'), require('@/assets/images/users/post_2.jpg')],
        status: 'Atraso',
        date: '13 Jul, 23',
        comment: 0
    },
    {
        id: 4,
        image: require('@/assets/images/companies/linkedin_logo.png'),
        text: 'Prospecção testes 000001',
        subtext: 'usuário testes 0009 marcou projeto como concluído',
        users: [require('@/assets/images/users/post_3.jpg')],
        status: 'Concluído',
        date: '14 Jul, 23',
        comment: 202
    },
    {
        id: 5,
        image: require('@/assets/images/companies/twitter_logo.png'),
        text: 'Prospecção testes 00002',
        subtext: 'Descrição última interação de usuário testes 0001',
        users: [require('@/assets/images/users/post_3.jpg'), require('@/assets/images/users/post_1.jpg')],
        status: 'Concluído',
        date: '13 Jul, 23',
        comment: 194
    },
    {
        id: 6,
        image: require('@/assets/images/companies/youtube_logo.png'),
        text: 'Prospecção testes 000005',
        subtext: 'Descrição última interação de usuário testes 0009',
        users: [require('@/assets/images/users/post_2.jpg')],
        status: 'Pendente',
        date: '24 Jul, 23',
        comment: 0
    },
    {
        id: 7,
        image: require('@/assets/images/companies/tiktok_logo.png'),
        text: 'Prospecção testes 000999',
        subtext: 'Descrição última interação de usuário testes 0001',
        users: [require('@/assets/images/users/post_1.jpg')],
        status: 'Atraso',
        date: '15 Jul, 23',
        comment: 0
    },
];

export { projectData };